<p-table stripedRows #dataTable
    [value]="items"
    dataKey="id"
    scrollHeight="flex"
    [scrollable]="true"
    [virtualScroll]="true"
    [virtualRowHeight]="dropdownItemHeight"
    [columns]="cols"
    [reorderableColumns]="true"
>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td [attr.colspan]="cols?.length" style="text-align: center">
                <div class="tabulator-placeholder">
                    <span> No Data Available </span>
                </div>
            </td>
        </tr>
    </ng-template>

    <ng-template #header>
        <tr>
            <th *ngFor="let col of cols" pReorderableColumn>
                {{ col.header }}
                <p-sortIcon
                    [pSortableColumn]="col.field"
                    [field]="col.field"
                    ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"
                ></p-sortIcon>
                <p-columnFilter type="text" matchMode="contains" [field]="col.field" display="menu" class="ml-auto" />
            </th>
        </tr>
    </ng-template>
    <ng-template #body let-item>
        <tr>
            <td
                *ngFor="let col of cols"
                [attr.title]="item[col.field]"
            >
                {{ item[col.field] }}
                <div style="display: none">
                    {{
                        moment(item[col.field]).isValid()
                            ? moment(item[col.field]).format('MM/DD/YYYY')
                            : item[col.field]
                    }}
                </div>
            </td>
        </tr>
    </ng-template>
</p-table>
